import { render, staticRenderFns } from "./InsightsKpi.vue?vue&type=template&id=27938083&scoped=true"
import script from "./InsightsKpi.vue?vue&type=script&lang=js"
export * from "./InsightsKpi.vue?vue&type=script&lang=js"
import style0 from "./InsightsKpi.vue?vue&type=style&index=0&id=27938083&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27938083",
  null
  
)

export default component.exports